import { ComponentProps } from 'react';
import AntdDrawer from 'antd/es/drawer';
import { DrawerClose } from '@/assets/svgFile/DrawerClose';
import './style.scss';

export default function Drawer(props: ComponentProps<typeof AntdDrawer>) {
    return <AntdDrawer width={860} closeIcon={<DrawerClose />} {...props} />;
}
